// Normalize a media URL: if it's a backend-relative /api/uploads/... path, prefix with backend origin
export const resolveMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/uploads/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  return url;
};
